/**
 * FAIR monogram path (Header asset) — used by page-loader draw animation.
 */
export const FAIR_PAGE_LOADER_MONOGRAM_PATH =
  'M38.6796 31.524L40.9065 31.4966C45.5367 31.3362 47.8797 29.4429 47.8797 25.6014C47.8797 21.3609 45.096 19.6534 40.2036 19.6534H9.61752V37.8437H13.1815V30.7495H21.0102V37.8437H24.5849V31.6551H34.6943L42.8992 37.8437H47.4692L40.4659 32.6428L38.6796 31.524ZM21.0102 28.1364H13.1815V22.4563H21.0102V28.1364ZM24.5849 29.1515V22.4563H39.9672C42.9851 22.4563 44.2168 23.3892 44.2168 25.8166C44.2168 28.2439 42.9873 29.1515 39.9672 29.1515H24.5849Z'

/**
 * Loader A «Draw, fill, breathe» (designer spec 2026-10-19, `fair-loader-A-spec.md`):
 * the FAIR short mark, cropped tight — one continuous line along the outline, then the fill.
 */
export const FAIR_PAGE_LOADER_MARK_PATH =
  'M521.91 425.36L551.958 424.99C614.433 422.826 646.047 397.279 646.047 345.446C646.047 288.229 608.487 265.189 542.474 265.189H129.774V510.631H177.863V414.909H283.496V510.631H331.73V427.128H468.136L578.845 510.631H640.508L546.012 440.456L521.91 425.36ZM283.496 379.65H177.863V303.009H283.496V379.65ZM331.73 393.347V303.009H539.283C580.005 303.009 596.624 315.597 596.624 348.349C596.624 381.101 580.034 393.347 539.283 393.347H331.73Z'
export const FAIR_PAGE_LOADER_MARK_VIEWBOX = { x: 125, y: 262, width: 526, height: 252 }
/** Mark width on every breakpoint (spec: 72, mobile the same until design says otherwise). */
export const FAIR_PAGE_LOADER_MARK_SIZE = 72
/** Outline width in screen px, whatever the mark size. */
export const FAIR_PAGE_LOADER_LINE_PX = 1.5

/** Timeline, t = 0 when the overlay starts to appear. */
export const FAIR_PAGE_LOADER_DRAW_MS = 1000
export const FAIR_PAGE_LOADER_REVEAL_DELAY_MS = 850
export const FAIR_PAGE_LOADER_REVEAL_MS = 500
export const FAIR_PAGE_LOADER_BREATHE_DELAY_MS = 1450
export const FAIR_PAGE_LOADER_BREATHE_MS = 2600

/**
 * Up to this point the page's own skeleton covers the wait — the overlay never shows for a
 * load that settles sooner.
 */
export const FAIR_PAGE_LOADER_SHOW_DELAY_MS = 1200
export const FAIR_PAGE_LOADER_FADE_IN_MS = 250

/**
 * Inline / products loader (`motion="spin"`):
 * short snake segment crawls along FR contour (pathLength=1).
 */
export const FAIR_PAGE_LOADER_SPIN_INTRO_MS = 160
/** One full lap of the snake around the monogram path. */
export const FAIR_PAGE_LOADER_FILL_MS = 2000
/** Visible snake length as fraction of normalized path (0–1). */
export const FAIR_PAGE_LOADER_SNAKE_RATIO = 0.14

/** Default size for inline product-grid loading. */
export const FAIR_PAGE_LOADER_INLINE_SIZE = 72

/** Once shown, the overlay stays until the intro (draw + fill) has played — spec `MIN_VISIBLE`. */
export const FAIR_PAGE_LOADER_MIN_MS = 1450

/** Hard cap — never stick if a page forgets `markReady`. */
export const FAIR_PAGE_LOADER_MAX_MS = 5000

/**
 * Grace window after every readiness gate reports in (FE-003.1). Sections below the
 * fold mount a tick or two after the page shell, so a gate registered late must be
 * able to re-arm the overlay before it starts fading. Dismissal is additionally held
 * to the next painted frame.
 */
export const FAIR_PAGE_LOADER_SETTLE_MS = 120

/** Exit: the overlay fades out while the page underneath is already in place. */
export const FAIR_PAGE_LOADER_FADE_MS = 400

export type FairPageLoaderMotion = 'draw' | 'spin'
